import { Component } from '@angular/core';

@Component({
  selector: 'app-priority-modal',
  templateUrl: './priority-modal.component.html',
  styleUrls: ['./priority-modal.component.scss']
})
export class PriorityModalComponent {}
